import React from 'react';

const Divider = () => {
  return <div className="mx-1 text-base-white">|</div>;
};

export default Divider;
